export default __webpack_public_path__ + "85f6d1a.png";